import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { setPtKPIsForCurrentRun, setPtRuns } from '../actions/pt'
import { PTKPI, PTRun } from '../../shared/model'

type PTState = {
  ptRuns: PTRun[] | null
  currentPtRun: PTRun | null
  ptKPIs: Record<string, PTKPI[]> | null
}

const initialState: PTState = {
  ptRuns: null,
  currentPtRun: null,
  ptKPIs: null,
}

const ptSlice = createSlice({
  name: 'currentPT',
  initialState,
  reducers: {
    setCurrentRun: (state, action: PayloadAction<PTRun | null>) => {
      state.currentPtRun = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setPtRuns.fulfilled, (state, action: PayloadAction<PTRun[] | null>) => {
      state.ptRuns = action.payload
      if (action.payload && action.payload.length > 0)
        state.currentPtRun = action.payload[action.payload.length - 1]
      else state.currentPtRun = null
    })
    builder.addCase(
      setPtKPIsForCurrentRun.fulfilled,
      (state, action: PayloadAction<{ runId: number; results: PTKPI[] } | null>) => {
        if (action.payload) {
          state.ptKPIs = {
            ...state.ptKPIs,
            [action.payload.runId]: action.payload.results,
          }
        }
      },
    )
  },
})

export const ptActions = ptSlice.actions
export default ptSlice.reducer
